import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';
import { Observable, Subscription, interval } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SaveFormCanequalityComponent } from './save-form-canequality/save-form-canequality.component';
import { GlobalConstants } from 'src/environments/global-constants';
import { yearCr, yearCrCPC } from '../../../../environments/global-constants';
import { data } from 'jquery';
import { EncryptUrlService } from 'src/app/services/encrypt-url.service';
import { CustomService } from 'src/app/core/services/custom.service'
import html2canvas from 'html2canvas';
import axios from 'axios';
@Component({
  selector: 'app-canequality',
  templateUrl: './canequality.component.html',
  styleUrls: ['./canequality.component.css']
})
export class CanequalityComponent {

  private subscription: Subscription;
  regtruck: string | null = null;
  canqualityForm: FormGroup;
  previewUrl: string | ArrayBuffer | null = null;
  searchForm: FormGroup;
  searchResults: any[] = [];
  canequalityData: any[] = [];
  allcanequalityData: any[] = [];
  // canequality10Data: any[] = [];
  displayedColumns: string[] = ['REGTRUCK', 'fmname', 'action', 'expand'];
  qData: any[] = [];
  searchTerm: string = '';
  yearCPC: string = '2526';
  dateLabel: string | null = null;
  longText = '';
  expandedElement?: any | null = null;
  selectedDate: Date | null = null;
  public reportdate: string | null = null;
  @ViewChild('captureDiv') captureDiv!: ElementRef;
  @ViewChild('tb_caneqc', { static: false }) caneqcTable: any;
  showForm = false;
  dataid = 0;
  correctionValue = ''

  constructor(
    private brdservice: BrdsqlService,
    private custService: CustomService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private encryptService: EncryptUrlService,
  ) {

    // this.yearCPC = yearCrCPC();
    console.log('this.yearCPC :', this.yearCPC)

    this.searchForm = this.fb.group({
      searchTerm: [''],
    });

  }

  ngOnInit(): void {

  }

  showFormCorrection(showform: boolean, id: number) {
    console.log('id: ', id)
    this.dataid = id
    if (showform == true) {
      this.showForm = true;
    } else {
      this.showForm = false;
    }
    console.log('this.showForm :', this.showForm);
  }

  saveCorrection(id: number = this.dataid, correction: string = this.correctionValue) {
    console.log('id correction : ', id, correction)
    this.brdservice.saveCorrectionSupcode(id, correction)
      .then(res => {
        console.log('save res: ', res)
        alert('บันทึกข้อมูลแล้ว');
      }).catch(err => { throw err })
      .finally(() => {

      });

  }

  toggleRow(element: any): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  isRowExpanded(element: any): boolean {
    return this.expandedElement === element;
  }

  onSearch(): void {
    // console.log('yearCPC/searchTerm :', this.yearCPC, this.searchTerm)
    if (this.searchTerm.trim()) {
      this.spinner.show()
      this.subscription = this.brdservice.searchRegtruck_canequality(this.yearCPC, this.searchTerm)
        .subscribe({
          next: (res) => {
            // console.log('searchRegtruck_canequality res :', res);
            if (res.code !== "EREQUEST") {
              this.searchResults = res.recordset;  //
            } else {
              alert('!! มีข้อผิดพลาดในการค้นข้อมูลจากเซริ์ฟเวอร์ กรุณาลองอีกครั้ง..')
              this.searchResults = []
            }
          }, error(err) {
            console.log('err:', err)
          }, complete: () => {
            this.spinner.hide();
          },
        })
    } else {
      console.warn('Search term is empty');
    }
  }

  openForm(): void {
    const dialogRef = this.dialog.open(SaveFormCanequalityComponent, {
      width: '400px',
      height: '500px', // ความสูงของ Dialog
      data: this.searchResults,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.qData.push(result);
        this.getCanequalityData();
      }
    });
  }

  onDateChange(e) {
    let date = e.target.value
    date = this.custService.Date2en(date)
    this.reportdate = date;
    // console.log('reportdate : ', this.reportdate)
    this.getDateToday(date);
  }

  getDateToday(date: string) {
    const today = new Date(date);
    const thaiDate = today.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    });
    this.dateLabel = thaiDate;
  }

  getCanequalityData(): void {
    const date = this.reportdate
    console.log('reportdate : ', date)
    this.canequalityData = []
    this.spinner.show()
    // const date: string = this.custService.Date2en(this.selectedDate);
    this.subscription = this.brdservice.getCanequalityData(date)
      .subscribe({
        next: (res: any) => {
          // console.log('canequalityData res : ', res)
          if (res.code !== "EREQUEST") {
            if (res.recordset.length == 0) {
              alert('!! ไม่พบข้อมูลของวันที่เลือก กรุณาตรวจสอบ..')
              this.canequalityData = []
            } else {
              this.canequalityData = res.recordset;  //
            }
          } else {
            alert('!! มีข้อผิดพลาดในการค้นข้อมูลจากเซริ์ฟเวอร์ กรุณาลองอีกครั้ง..')
            this.canequalityData = []
          }
        }, error(err) {

        }, complete: () => {
          this.spinner.hide();
        },
      })
  }

  exportToPNG() {
    setTimeout(() => { // รอให้รูปภาพโหลดเสร็จ
      html2canvas(this.captureDiv.nativeElement, {
        useCORS: true, // ใช้ CORS สำหรับรูปภาพจากภายนอก
        allowTaint: true,
        logging: false
      }).then(canvas => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'รายงานอ้อยไม่ได้คุณภาพวันที่_' + this.reportdate + '.png';
        link.click();
      });
    }, 1000);
  }

  exportAsPNG() {
    //const div = document.getElementById('captureDiv'); // เลือก div ที่ต้องการ capture
    const div = this.captureDiv.nativeElement;
    if (div) {
      html2canvas(div, {
        useCORS: true, // ใช้ CORS สำหรับรูปภาพจากภายนอก
        allowTaint: true,
        logging: false
      }).then(canvas => {
        const image = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = image;
        link.download = "exported-image.png";
        link.click();
      });
    }
  }

  async loadAllCanqualityYear() {
    const yearId = this.yearCPC
    this.allcanequalityData = []
    this.spinner.show()
    await this.brdservice.getAllCanequalityData(yearId)
      .then(res => {
        console.log('getAllCanequalityData res : ', res)
        if (res.data) {
          if (res.data.length == 0) {
            alert('!! ไม่พบข้อมูลในระบบของปีที่เลือก กรุณาตรวจสอบ..')
            this.allcanequalityData = []
          } else {
            this.allcanequalityData = res.data;  //
          }
        } else {
          alert('!! มีข้อผิดพลาดในการค้นข้อมูลจากเซริ์ฟเวอร์ กรุณาลองอีกครั้ง..')
          this.allcanequalityData = []
        }
      })
      .catch(err => { throw err })
      .finally(() => {
        this.spinner.hide();
      });

  }

  ExportExcelData1() {

  }

  printPage() {
    window.print();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      console.log('Unsubscribed!');
    }
  }

}
